import styled from 'styled-components';
import {  Typography,Box } from '@mui/material';


export const FooterWrapper = styled.footer`
  background-color: #4a7061;
  color: white;
  padding: 3rem 0 2rem;
`;

export const FooterTitle = styled(Typography)`
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: white;
`;

export const ContactItem = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;
  color: rgba(255, 255, 255, 0.8);
  
  svg {
    margin-right: 10px;
    font-size: 1.2rem;
  }
`;

export const Copyright = styled(Typography)`
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
`;